<template>
  <div class="corps-modal-liste-faces">
    <v-client-table ref="tableFacesReseauTempo" :data="reseau.listeFaces"
                    :columns="columns" @filter="onFilterChange"
                    :options="options" >
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox"
                id="checkbox"
                :value="props.row"
                v-model="props.row.selected" @click="ajoutFaceSelect(props.row)"
                :disabled="disabled">
      </div>
      <div slot="dispo" slot-scope="props"
          class="image is-24x24 button noHandCursor centrer_disponibilite"
          v-bind:class="props.row.dispoClass">
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { TEXTS, PER_PAGE_VALUE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/panier-mutation-type';

const Panier = createNamespacedHelpers('panier');

export default {
  name: 'liste-faces-reseau-num',
  props: ['reseau', 'disabled', 'generateMarker'],
  data() {
    return {
      trad: {
        panCode: '↑↓ Panneau',
        facCode: '↑↓ Face',
        format: '↑↓ Format',
        adresseCommercialeLibelle1: '↑↓ Adresse',
        codePostal: '↑↓ Code postal',
        ville: '↑↓ Ville',
        depCode: '↑↓ Dpt',
        dispo: 'Dispo',
        selected: '',
      },
      selectAllValue: true,
    };
  },
  computed: {
    columns() {
      return ['panCode', 'facCode', 'format', 'adresseCommercialeLibelle1', 'codePostal', 'ville', 'depCode'];
    },
    iconSelectTotal() {
      if (this.selectAllValue) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        headings: {
          panCode: this.trad.panCode,
          facCode: this.trad.facCode,
          format: this.trad.format,
          adresseCommercialeLibelle1: this.trad.adresseCommercialeLibelle1,
          codePostal: this.trad.codePostal,
          ville: this.trad.ville,
          depCode: this.trad.depCode,
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          dispo: this.trad.dispo,
        },
        filterByColumn: true,
        listColumns: {
          dispo: [{
            id: 3,
            text: 'Disponible',
          },
          {
            id: 1,
            text: 'Indisponible',
          }],
        },
        initFilters: {
          dispo: '',
        },
        filterable: ['dispo', 'panCode', 'facCode', 'format', 'adresseCommercialeLibelle1', 'codePostal', 'ville', 'depCode'],
        sortable: ['dispo', 'panCode', 'facCode', 'format', 'adresseCommercialeLibelle1', 'codePostal', 'ville', 'depCode'],
        perPageValues: PER_PAGE_VALUE,
        perPage: 9999999999,
        texts: TEXTS,
        columnsClasses: {
          dispo: 'ellipsis colonneDispo',
          ville: 'ellipsis colonneville',
          adresseCommercialeLibelle1: 'ellipsis colonneAdrLibelle1',
          format: 'ellipsis colonneFormat',
          facCode: 'ellipsis colonneFacCode',
          panCode: 'ellipsis colonnePanCode',
          codePostal: 'ellipsis colonnecodePostal',
          depCode: 'ellipsis colonneDepartement',
        },
      };
    },
  },
  methods: {
    ...Panier.mapMutations({
      setReseauxTempoPanier: types.SET_PRODUIT_TYPE_RESEAU_TEMPO,
    }),
    ajoutFaceSelect(faceSelec) {
      const face = this.reseau.extensionOpportunite.faces.find((el) => {
        return faceSelec.facNum === el.facNum;
      });
      face.selected = !face.selected;
      this.generateMarker();
    },
    selectAll() {
      const facesNum = this.$refs.tableFacesReseauTempo.allFilteredData.map((el) => el.facNum);
      this.reseau.extensionOpportunite.faces.filter((el) => {
        return facesNum.includes(el.facNum);
      }).forEach((el) => {
        el.selected = this.selectAllValue;
      });
      this.selectAllValue = !this.selectAllValue;
      this.setReseauxTempoPanier({
        semaine: this.reseau.extensionOpportunite.semaine,
        annee: this.reseau.extensionOpportunite.annee,
        num: this.reseau.num,
        faces: this.reseau.extensionOpportunite.faces,
      });
      this.generateMarker();
    },
    onFilterChange() {
      this.selectAllValue = true;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/consultation/listeFacesReseau.vue